import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import isSingleDigit from 'portal-modules/auth/utils/validate-single-digit'

const CountDownMinutesTimer = ({ minutes }) => {
  const [state, setState] = useState({
    seconds: 0,
    minutes: minutes,
  })
  var timer
  useEffect(() => {
    timer = setInterval(() => {
      setState({ ...state, seconds: state.seconds - 1 })
      if (state.seconds === 0) {
        setState({
          minutes: state.minutes > 0 ? state.minutes - 1 : 0,
          seconds: state.minutes > 0 ? 60 : 0,
        })
      } else if (state.seconds <= 0) {
        setState({
          minutes: 0,
          seconds: 0,
        })
      }
    }, 1000)
    return () => clearInterval(timer)
  })
  return (
    <span>
      {isSingleDigit(state.minutes)}:{isSingleDigit(state.seconds)}{' '}
      {__('minutes')}
    </span>
  )
}

CountDownMinutesTimer.propTypes = {
  minutes: PropTypes.number.isRequired,
}

export default CountDownMinutesTimer
